import getProductTitle, { ProductIdValue } from './getProductTitle';
import i18n from './i18n';
import { DEFAULT_TITLE } from '../consts';

type getRouteTitleType = {
  titleKey?: string;
  productId?: ProductIdValue | null;
};

const getRouteTitle = ({ titleKey, productId }: getRouteTitleType) => {
  if (titleKey && productId) {
    return `${i18n.t(titleKey)} - ${getProductTitle(productId)}`;
  } else if (titleKey && !productId) {
    return `${i18n.t(titleKey)}`;
  } else if (!titleKey && productId) {
    return `${getProductTitle(productId)}`;
  }

  return DEFAULT_TITLE;
};

export default getRouteTitle;
